import { TrackingEventAction, sendTrackingEvent } from '../services/service.tracking';
import { ImageCategory, getCategoryIndexFromValue } from '../utils/utils.image-capture';

export const ImageCaptureEvents = {
  Impression: 'adtn_photo-ico_condition_img',
  UploadSuccess: 'button::addphoto_success::',
  UploadFail: 'button::addphoto_fail::',
  Delete: 'cta::addphoto_delete',
  Guidelines: 'text-link::see-photo-guidelines',
  AddPhoto: 'cta::add_photo',
};

export const trackImageCapture = (result: string, eventAction: TrackingEventAction, category?: ImageCategory) => {
  const tag = category ? getCategoryIndexFromValue(category) + 1 : '';
  const eventResult = `${result}${tag}`;
  sendTrackingEvent({
    event: 'analytics_event',
    eventAction,
    eventResult,
    eventNonInteractive: false,
  });
};
